import sanitizeHtml from 'sanitize-html';

export function sanitizeInput(input) {
  const result = sanitizeHtml(input, {
    allowedTags: [
      'a',
      'abbr',
      'address',
      'article',
      'b',
      'bdi',
      'bdo',
      'blockquote',
      'br',
      'caption',
      'cite',
      'code',
      'col',
      'colgroup',
      'data',
      'dd',
      'dfn',
      'div',
      'dl',
      'dt',
      'em',
      'figcaption',
      'figure',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'hgroup',
      'hr',
      'i',
      'iframe',
      'img',
      'kbd',
      'li',
      'mark',
      'ol',
      'p',
      'q',
      'rb',
      'rp',
      'rt',
      'rtc',
      'ruby',
      's',
      'samp',
      'small',
      'span',
      'strong',
      'sub',
      'sup',
      'table',
      'tbody',
      'td',
      'tfoot',
      'th',
      'thead',
      'time',
      'tr',
      'u',
      'ul',
      'var',
      'wbr',
    ],
    allowedAttributes: {
      a: ['href', 'target'],
      iframe: ['id', 'title', 'src', 'frameborder', 'allow', 'allowfullscreen'],
      img: ['src', 'srcset', 'alt', 'title', 'loading'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesByTag: {
      img: ['data', 'http', 'https'],
    },
    allowedIframeHostnames: [
      'www.youtube.com',
      'www.openstreetmap.org',
      'www.twitter.com',
    ],
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
  });

  return result;
}
